import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "mapwrap"
};
const _hoisted_2 = ["id"];
const _hoisted_3 = {
  class: "curvetools",
  id: "curvetools"
};
const _hoisted_4 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CloseBold = _resolveComponent("CloseBold");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_Select = _resolveComponent("Select");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    id: `map${$props.id}`,
    class: "map_content",
    ref: `map${$props.id}`
  }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_tooltip, {
    class: "box-item",
    effect: "dark",
    content: "还原最初线段",
    placement: "top"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      onClick: _withModifiers($options.resetrouteLine, ["stop"])
    }, {
      default: _withCtx(() => [_createVNode(_component_CloseBold)]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  }), _createVNode(_component_el_tooltip, {
    class: "box-item",
    effect: "dark",
    content: "确定",
    placement: "top"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      onClick: _withModifiers($options.confirmrouteLine, ["stop"])
    }, {
      default: _withCtx(() => [_createVNode(_component_Select)]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  })]), _createVNode(_component_el_dialog, {
    modelValue: $data.dialogVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.dialogVisible = $event),
    title: "编辑区域列表",
    width: "220",
    top: "0",
    "append-to-body": true,
    modal: false
  }, {
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
      onClick: $options.quitPointHandle
    }, {
      default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("预览")])),
      _: 1,
      __: [1]
    }, 8, ["onClick"]), _createVNode(_component_el_button, {
      type: "primary",
      onClick: $options.confirmPointHandle
    }, {
      default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("保存")])),
      _: 1,
      __: [2]
    }, 8, ["onClick"])])]),
    _: 1
  }, 8, ["modelValue"])]);
}